import {pdfjs} from "react-pdf"

export function getPdfWorkerPath(){
    return `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`
}